/*
 * Polyfills
 */
import './polyfills/object-fit';

/*
 * Modules
 */

import './modules/sliders.js';
import './modules/popups.js';
import './modules/field-number.js';
import './modules/nav-triggers.js';
import './modules/faq-dropdowns.js';
import './modules/field-placeholders.js';
import './modules/thought-leaders.js';
import './modules/header-functions.js';
import './modules/scripts.js';
import './modules/dropdowns.js';





